import { create, StoreApi, UseBoundStore } from 'zustand';
import { toast } from 'react-toastify';
import getErrorMessage from '../utils/error';
import { ICompanyProfileStore } from '../types/types';
import { getCompanyProfile, updateCompanyProfile } from '../utils/api';

const useCompanyProfile: UseBoundStore<StoreApi<ICompanyProfileStore>> = create((set) => ({
  profile: null,
  loading: false,

  fetchProfile: async () => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await getCompanyProfile();
      if (!success) throw new Error(message);

      set(() => ({ profile: data }));
      return { success, message, data };
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message, { position: 'top-right' });
      return { success: false, message };
    } finally {
      set(() => ({ loading: false }));
    }
  },

  editProfile: async (profileData) => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await updateCompanyProfile(profileData);
      if (!success) throw new Error(message);
      set(() => ({ profile: data }));
      toast.success(message, {
        position: 'top-right',
      });
      return { message, success };
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message, {
        position: 'top-right',
      });
      return { message, success: false };
    } finally {
      set(() => ({ loading: false }));
    }
  },
}));

export default useCompanyProfile;
